import { render, staticRenderFns } from "./FormQuery.vue?vue&type=template&id=dd7fc0ec"
import script from "./FormQuery.vue?vue&type=script&lang=js"
export * from "./FormQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports